var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2039_88)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_2039_88)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.03885C8.28948 2.03885 2.03885 8.28948 2.03885 16C2.03885 23.7106 8.28948 29.9612 16 29.9612C23.7106 29.9612 29.9612 23.7106 29.9612 16C29.9612 8.28948 23.7106 2.03885 16 2.03885ZM1.96118 16C1.96118 8.24658 8.24658 1.96118 16 1.96118C23.7535 1.96118 30.0389 8.24658 30.0389 16C30.0389 23.7535 23.7535 30.0389 16 30.0389C8.24658 30.0389 1.96118 23.7535 1.96118 16Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12.0779C13.8338 12.0779 12.0777 13.834 12.0777 16.0002C12.0777 18.1665 13.8338 19.9226 16 19.9226C18.1662 19.9226 19.9223 18.1665 19.9223 16.0002C19.9223 13.834 18.1662 12.0779 16 12.0779ZM12 16.0002C12 13.7911 13.7909 12.0002 16 12.0002C18.2091 12.0002 20 13.7911 20 16.0002C20 18.2094 18.2091 20.0002 16 20.0002C13.7909 20.0002 12 18.2094 12 16.0002Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13.3201C14.52 13.3201 13.3203 14.5198 13.3203 15.9997C13.3203 17.4796 14.52 18.6793 16 18.6793C17.4799 18.6793 18.6796 17.4796 18.6796 15.9997C18.6796 14.5198 17.4799 13.3201 16 13.3201ZM13.2427 15.9997C13.2427 14.4769 14.4772 13.2424 16 13.2424C17.5228 13.2424 18.7572 14.4769 18.7572 15.9997C18.7572 17.5225 17.5228 18.757 16 18.757C14.4772 18.757 13.2427 17.5225 13.2427 15.9997Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9612 0H16.0389V32H15.9612V0Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9609L32 16.0386L-3.39506e-09 16.0386L0 15.9609L32 15.9609Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6019 0H26.6796V32H26.6019V0Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6407 0H10.7184V32H10.6407V0Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2815 0H21.3592V32H21.2815V0Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32031 0H5.39798V32H5.32031V0Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 26.6016L32 26.6792L-3.39506e-09 26.6792L0 26.6016L32 26.6016Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 10.6406L32 10.7183L-3.39506e-09 10.7183L0 10.6406L32 10.6406Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 21.2812L32 21.3589L-3.39506e-09 21.3589L0 21.2812L32 21.2812Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 5.32031L32 5.39798L-3.39506e-09 5.39798L0 5.32031L32 5.32031Z",
    fill: "#D6BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5103 21.7309C23.4515 21.6132 23.4515 21.4662 23.5103 21.3338C24.4662 19.4809 25.2309 18.0103 25.2309 15.6279C25.2309 10.1573 20.6721 5.76016 15.1573 6.01016C10.2308 6.24545 6.23075 10.2602 6.01016 15.1867C5.76016 20.7162 10.1573 25.2603 15.6279 25.2603C15.8485 25.2603 16.0544 25.2456 16.275 25.2309L24.8633 24.9956C24.9662 24.9956 25.0397 24.878 24.9956 24.7897L23.5103 21.7309Z",
    fill: "url(#paint1_linear_2039_88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7014 15.6573C18.7014 13.922 17.2455 12.5102 15.4808 12.6131C13.9367 12.6867 12.672 13.9514 12.5984 15.4808C12.5102 17.2455 13.9073 18.7014 15.6426 18.7014C15.7602 18.7014 17.3044 18.6132 17.7014 18.5838C17.7603 18.5838 17.8044 18.5397 17.8338 18.4956L18.4514 16.8779C18.6132 16.4955 18.7014 16.0838 18.7014 15.6573Z",
    fill: "#FCFCFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2039_88",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2039_88",
    x1: 9.5,
    y1: 8,
    x2: 27.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F56D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C177FB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2039_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcn);
export default __webpack_public_path__ + "static/media/logo-icn.accbe54529141964975d72eaab6f9978.svg";
export { ForwardRef as ReactComponent };